import React from 'react';

interface IChevronRightProps {
	size?: string;
	fill?: string;
	className?: string;
}

export const ChevronRight = ({ size = '24', fill, className }: IChevronRightProps) => (
	<svg aria-hidden="true" className={className} width={size} height={size} viewBox="0 0 24 24" fill="none">
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M16.5708 12.8434L11.2374 18.1768L9.82321 16.7625L14.4494 12.1363L9.82321 7.51009L11.2374 6.09588L16.5708 11.4292C16.9613 11.8197 16.9613 12.4529 16.5708 12.8434Z"
			fill={fill || '#121212'}
		/>
	</svg>
);
